import { usePublisher, insertDirective$ } from '@mdxeditor/editor'
import IconButton from '@mui/material/IconButton'
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined'
import Tooltip from '@mui/material/Tooltip'
import useStore from 'reusable/mobx-store-utils'
import GapImagePluginStore from './GapImagePluginStore'
import { observer } from "mobx-react-lite"
import GapDialog from 'reusable/gap-dialog/GapDialog'
import FileUploadWithProgress from 'reusable/mui/file-uploads/FileUploadWithProgress'
import { useMarkdownStore } from 'reusable/markdown/MarkdownStore'
import { fileValidation } from '@gap/utils/file/file-utils'

export default observer(function GapImagePlugin() {
   const insertDirective = usePublisher(insertDirective$)
   const markdownStore = useMarkdownStore()

   const gapImagePluginStore = useStore(sp => new GapImagePluginStore(sp), {
      insertDirective,
      markdownStore
   })

   return <>
      <Tooltip title="Insert image">
         <IconButton size="small" onClick={gapImagePluginStore.modalState.open}>
            <ImageOutlinedIcon fontSize="small" />
         </IconButton>
      </Tooltip>

      <GapDialog modalState={gapImagePluginStore.modalState} size="small" title="Add image">
         <FileUploadWithProgress
            files={gapImagePluginStore.file ? [gapImagePluginStore.file] : []}
            getPresignedUrl={gapImagePluginStore.getPresignedUrl}
            onFilesValidated={gapImagePluginStore.onFilesValidated}
            subtext="Upload an image"
            maxFiles={1}
            maxSize={fileValidation['markdown-files'].maxSizeBytes}
            appendUlids
            accept={{ 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'] }}
         />
      </GapDialog>
   </>
})
